import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, HeartIcon } from 'lucide-react';
export function EliteSection() {
  return <section className="py-16 px-4 bg-surface-light" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-67">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-68">
            Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-69">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm" data-id="element-70">
            <div className="flex items-start gap-4 mb-4" data-id="element-71">
              <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center flex-shrink-0" data-id="element-72">
                <ShieldCheckIcon className="w-6 h-6 text-white" data-id="element-73" />
              </div>
              <div data-id="element-74">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-75">
                  🛡️ Élite 1 — Stretching Seguro 360
                </h3>
              </div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-76">
              El manual clínico del instructor moderno. Protocolos específicos
              para hernias, prótesis de cadera y rodilla, osteoporosis,
              hipertensión, fibromialgia y más.
            </p>
            <p className="text-gray-900 font-semibold" data-id="element-77">
              No improvises más cuando entre un alumno con una condición médica
              compleja. Sabé exactamente qué hacer y qué evitar en cada
              situación.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm" data-id="element-78">
            <div className="flex items-start gap-4 mb-4" data-id="element-79">
              <div className="w-12 h-12 rounded-lg bg-accent flex items-center justify-center flex-shrink-0" data-id="element-80">
                <HeartIcon className="w-6 h-6 text-white" data-id="element-81" />
              </div>
              <div data-id="element-82">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-83">
                  👩 Élite 2 — Stretching para la Mujer y Maternidad
                </h3>
              </div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-84">
              El nicho de mayor crecimiento del mercado. Protocolos completos
              para embarazo trimestre a trimestre, postparto, diástasis
              abdominal, cicatriz de cesárea, ciclo menstrual y suelo pélvico.
            </p>
            <p className="text-gray-900 font-semibold" data-id="element-85">
              Las mujeres en etapa de maternidad buscan instructores
              especializados y pagan hasta un 50% más por seguridad. Con este
              ebook, sos uno de ellos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}